// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3CDSr","signatureButtonsRight":"ModalSign_signatureButtonsRight__2YHdF"};